import styles from "./DeviceSessions.module.css";

/**
 * Body of the Sessions tab on the device-detail page. Mounted only when
 * `featureFlagRoute` in `DevicesRoutes` admits `/devices/:deviceId/sessions`
 * under the `release-sessions` flag; with the flag off the route redirects to
 * the device's Datasets tab and this component never mounts.
 *
 * Currently a static placeholder shell, ahead of the sessions list and detail
 * views that will populate this surface.
 */
export function DeviceSessions() {
  return (
    <section className={styles.container}>
      <h2 className={styles.heading}>Sessions</h2>
      <p className={styles.body}>Sessions for this device will appear here.</p>
    </section>
  );
}
